// =============================================================================
// Header — compact-on-scroll with hysteresis + mobile menu toggle.
// Hysteresis: compact past COMPACT_AT, return to expanded only below EXPAND_AT
// — the gap eliminates bouncing when scroll hovers near the threshold.
// =============================================================================
(function ($) {
    'use strict';

    $(function () {
        const $header = $('[data-header]');
        const $toggle = $('[data-menu-toggle]');
        const $body   = $('body');

        if (!$header.length) { return; }

        const COMPACT_AT = 120;
        const EXPAND_AT  = 40;
        let isScrolled = false;
        let ticking = false;

        function updateHeaderState() {
            const y = window.pageYOffset;

            if (!isScrolled && y > COMPACT_AT) {
                isScrolled = true;
                $header.addClass('is-scrolled');
            } else if (isScrolled && y < EXPAND_AT) {
                isScrolled = false;
                $header.removeClass('is-scrolled');
            }
            ticking = false;
        }

        function onScroll() {
            if (!ticking) {
                window.requestAnimationFrame(updateHeaderState);
                ticking = true;
            }
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        updateHeaderState();

        $toggle.on('click', function () {
            const opened = $body.toggleClass('is-menu-open').hasClass('is-menu-open');
            $(this).attr('aria-expanded', opened ? 'true' : 'false');
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' && $body.hasClass('is-menu-open')) {
                $body.removeClass('is-menu-open');
                $toggle.attr('aria-expanded', 'false').trigger('focus');
            }
        });

        // Navigable links close the drawer. Dropdown / mega triggers are
        // excluded — they expand their panel instead of dismissing the menu.
        $(document).on('click', '.main-nav__link:not([data-dropdown-trigger]):not([data-mega-trigger]), .main-nav__mobile-action, .main-nav__mobile-locations .location', function () {
            if ($body.hasClass('is-menu-open')) {
                $body.removeClass('is-menu-open');
                $toggle.attr('aria-expanded', 'false');
            }
        });
    });
})(jQuery);
